const styles = theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    alignSelf: 'stretch',
    borderRadius: '8px',
    gap: '16px',
    cursor: 'pointer',
  },

  headerContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    cursor: 'pointer',
  },
  section: {
    width: '100%',
  },
  title: {
    width: '90%',
    color: 'var(--Color---Dark, #919EAB)',
    fontfamily: 'Inter',
    fontsize: '14px',
    fontstyle: 'normal',
    fontweight: '400',
    lineheight: '150%' /* 21px */,
  },
  header: {
    color: 'var(--mcg-darkgray, #282F35)',
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%',
    margin: 0,
  },

  expandButton: {
    padding: '4px',
    color: 'var(--mcg-darkgray, #282F35)',
    '&:hover': {},
  },

  expandIcon: {
    fontSize: '20px',
    transition: 'transform 0.2s ease-in-out',
  },

  content: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '6px',
    padding: '12px',
    borderRadius: '8px',
    border: '1px solid var(--mcg-gray, #919EAB)',
    background: '#FFF',
  },

  fieldContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    width: '100%',
  },

  fieldLabel: {
    color: 'var(--mcg-dark, #002E47)',
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%',
    margin: 0,
  },

  textField: {
    '& .MuiOutlinedInput-root': {
      borderRadius: '8px',
    },
  },
  collapse: {
    width: '100%',
  },
})

export default styles
